import { useState } from "react";

import TabButton from "../../../../../Components/common/TabButton/TabButton";
import ThreatDetails from "./components/ThreatDetails";

import "./styles.scss";

const ThreatDetailsBySeverity = ({ data }) => {
  const [active, setActive] = useState("High");

  return (
    <div style={{ position: "relative" }}>
      <div className="button-block">
        <TabButton title="High" tabDisplay="High Sev. Detections" onClick={setActive} active={active} />
        <TabButton title="Medium" tabDisplay="Medium Sev. Detections" onClick={setActive} active={active} />
        <TabButton title="Low" tabDisplay="Low Sev. Detections" onClick={setActive} active={active} />
      </div>
      <ThreatDetails active={active} threatDetails={data} />
    </div>
  );
};

export default ThreatDetailsBySeverity;
